// soldier-story-modal.js                                        ~/js/swipers
///////////////////////////////////////////////////////////////////////////

import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export default (id) => {
  const SoldierStoryModalSwiper = new Swiper('.modal-swiper', {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    initialSlide: id,
    loop: false,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'progressbar',
    },
  });
};
